import { IconProps } from '@models/icons';

function TooltipCloseIcon({ color = '#FFFFFF', size = 14, ...rest }: IconProps) {
  return (
        <svg width={size} height={size} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"
             {...rest} >
            <path d="M11.084 2.91675L2.91738 11.0834" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <path d="M2.91699 2.91675L11.0836 11.0834" stroke={color} strokeWidth="2" strokeLinecap="round"/>
        </svg>
  );
}

export default TooltipCloseIcon;
